import { useRef } from 'react'
import { useRouter } from 'next/navigation'
import { useRipple } from '@/hooks/useRipple'

const ChevronLeftButton = () => {
  const ref = useRef(null)
  useRipple(ref, 'rgb(169, 174, 179, 0.3)')
  const router = useRouter()

  const handleClick = () => {
    router.push('/')
  }

  return (
    <button
      ref={ref}
      className="hover:opacity-80 w-12 h-12 p-[9px] overflow-hidden rounded-full relative"
      onClick={handleClick}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
        height={24}
        className="m-auto"
        fill={'#6b7280'}
      >
        <path d="M206.7 464.6l-183.1-191.1C18.22 267.1 16 261.1 16 256s2.219-11.97 6.688-16.59l183.1-191.1c9.152-9.594 24.34-9.906 33.9-.7187c9.625 9.125 9.938 24.37 .7187 33.91L73.24 256l168 175.4c9.219 9.5 8.906 24.78-.7187 33.91C231 474.5 215.8 474.2 206.7 464.6z" />
      </svg>
    </button>
  )
}

export default ChevronLeftButton
